/**
 * Created by lihanying on 2017/7/6.
 */
import { GETCLUBLEVELLIST } from './constants'

const initState = {}

export default function (state = initState, action) {
  switch (action.type) {
    case GETCLUBLEVELLIST:
      return Object.assign({}, state, { clubLevelList: action.payload })

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubLevel/reduce.js